<mat-toolbar>
    <span id="agenda-dokument-valg-dialog-tittel">{{ 'Velg dokumentinnhold' | translate }}</span>
    <span class="mellomrom"></span>
    <button mat-icon-button (click)="avbryt()">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>

<mat-dialog-content>
    <p>{{ 'Hva ønsker du å inkludere i agendadokumentet?' | translate }}</p>

    @for (del of deler(); track del.enumVerdi) {
        <mat-slide-toggle [formControl]="del.kontroll">
            {{ del.navn }}
        </mat-slide-toggle>
    }

    <inline-melding type="info" class="info-melding">
        {{ 'Dine valg vil lagres for alle eksisterende og fremtidige agendadokumenter i denne gruppen. Du kan når som helst endre dette senere.' | translate }}
    </inline-melding>
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-button (click)="avbryt()">{{ 'Avbryt' | translate }}</button>
    <button mat-raised-button color="primary" (click)="lagre()" [disabled]="lagrer()">{{ 'Lagre' | translate }}</button>
</mat-dialog-actions>
